import React, { lazy, Suspense } from 'react'
import { Button, Card, H2, List, Separator, useOverlay } from '@fs/zion-ui'
import { ContentUpload } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { ManageTreeRow } from './ManageTreeRow'
import { useUploadTree } from '../../../services/useUploadTree'

const UploadTreeOverlay = lazy(() => import('../import-page/UploadTreeOverlay'))

function ManageTreeGroup({ groupTitle, groups, isMobile, isOwnedTreesGroup }) {
  const overlay = useOverlay()
  const [t] = useTranslation()
  const { maxTrees, disableCreateTreeButton, refetchData } = useUploadTree()

  return (
    <Card margins="xs">
      <H2 size="H5">{groupTitle}</H2>
      <Separator size="xs" />
      <List>
        {groups.map((group, index) => (
          <ManageTreeRow
            key={group.id || group.file?.fileName || group.name}
            {...group}
            isMobile={isMobile}
            isLast={index === groups.length - 1}
          />
        ))}
      </List>
      {isOwnedTreesGroup && (
        <>
          <Separator size="xxs" />
          <Button
            disabled={disableCreateTreeButton}
            emphasis="medium"
            disabledDescription={
              maxTrees ? t('tree-import.create-tree-max-groups.error', { maxGroups: maxTrees }) : undefined
            }
            Icon={ContentUpload}
            data-testid="upload-gedcom-button.upload-gedcom.button"
            onClick={overlay.handleClick}
            linkName="Upload Gedcom Button"
          >
            {t('tree-import.create-files.button')}
          </Button>

          <Suspense fallback="">
            {(overlay.isOpen || overlay.transitioning) && (
              <UploadTreeOverlay overlay={overlay} onSuccess={refetchData} />
            )}
          </Suspense>
        </>
      )}
    </Card>
  )
}

export default ManageTreeGroup
